import { httpGet } from "@/utils/fetch";
import { getStorage, setStorage, removeStorage } from "@/utils/storage";

const WECHAT_APPID = "wxaa3aef56a421095d";
const TOKEN_KEY = "wechat_token";
const REDIRECT_URI =
  process.env.VUE_APP_WECHAT_REDIRECT_URI || window.location.origin + "/";

export function getToken() {
  return getStorage(TOKEN_KEY);
}

export function setToken(token) {
  setStorage(TOKEN_KEY, token);
}

export function removeToken() {
  removeStorage(TOKEN_KEY);
}

export function isWechatBrowser() {
  return /MicroMessenger/i.test(navigator.userAgent);
}

export function hasToken() {
  return !!getToken();
}

export function getCodeFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("code");
}

/**
 * 从URL的state参数中解析content
 */
export function getContentFromState() {
  const urlParams = new URLSearchParams(window.location.search);
  const state = urlParams.get("state");
  if (!state) return "";
  try {
    const stateObj = JSON.parse(state);
    return stateObj.content || "";
  } catch (e) {
    return "";
  }
}

/**
 * 构建包含content的state参数
 */
export function buildStateWithContent(content) {
  const stateObj = { content: content || "" };
  return encodeURIComponent(JSON.stringify(stateObj));
}

/**
 * 跳转到微信授权，将content编码到state中
 */
export function redirectToAuth(content) {
  if (!WECHAT_APPID) return;
  const redirectUri = encodeURIComponent(REDIRECT_URI);
  const state = content ? buildStateWithContent(content) : "STATE";
  const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${WECHAT_APPID}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`;
  window.location.replace(authUrl);
}

export function exchangeToken(code) {
  return httpGet("/wechat/wechat/index", { code });
}

export { WECHAT_APPID };
